module.exports = __webpack_public_path__ + "img/logo-miles-web.62173a82.svg";